import { Component, OnInit ,Input} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'video-modal-popup',
  templateUrl: './video-modal-popup.component.html',
  styles: []
})
export class VideoModalPopupComponent implements OnInit {
    @Input() videoUrl: string;
    safeUrl: SafeResourceUrl;
    constructor(public activeModal: NgbActiveModal, private sanitizer: DomSanitizer) {
    }

    ngOnInit(): void {
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoUrl);
    }

}
